@if (isLoadingResults || isLoadingResult) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}

<div
  id="users"
  class="page-layout simple left-sidebar inner-sidebar inner-scroll users-tableblockwrap w-full"
  [ngClass]="COLOR"
>
  <div class="user-headingwrap">
    <h3 class="mb-0 px-4 pt-4 pb-0 text-[14px]">
      <b>Create an unlimited number of user accounts within this window.</b>
      <br />
      The number of users who can access the system concurrently is determined by your amount of
      licenses. You currently have
      {{ login_data?.MAXLICENCES }} licences, to manage your licences navigate to the Subscription &
      Billing tab.
    </h3>
    <br />
    <div class="border-line"></div>
    <br />
  </div>
  <div class="content userheading-content" fxLayoutAlign="center">
    <div class="center more_tbl_clmn list_tbl_main w-full">
      <div class="matter-serach-div sticky_search_div responsive_auto">
        <!-- <form [formGroup]="userfilter">
      <mat-form-field class="example" appearance="outline">
        <mat-label>Show What</mat-label>
        <mat-select #value name="selected" (selectionChange)="UserTypeChange($event)"
          formControlName="ACTIVE">
          <mat-option value="">All Users</mat-option>
          <mat-option value="1">Active Users</mat-option>
          <mat-option value="0">Inactive Users</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button type="button" color="primary" id="refreshUser"
      (click)="loadData(lastFilter);">Refresh</button>
      <span class="appCues-blankSpace">
        <a href="javascript:void(0);">Link</a>
      </span>
    </form> -->
        <div class="user-button">
          <div class="minw-50">
            <!-- *ngIf="currentMenu == null" -->
            <form
              [formGroup]="userfilter"
              class="filter-menuwrap form-div-side flex items-center"
              id="filter-form-menu-wrap"
            >
              <div class="filter-menublock flex flex-wrap items-center">
                <div class="add-filterwrap">
                  <!-- <mat-icon class="icon-btn" id="refreshUser" (click)="refreshContactTab(false)">refresh</mat-icon > -->
                  <!-- [disabled]='totalApplicableFilterCount == userfilter.controls.FILTERS["controls"].length' -->
                  <button
                    mat-button
                    [matMenuTriggerFor]="dummyButton"
                    [disabled]="true"
                    style="display: none"
                  >
                    Filters
                  </button>
                  <mat-menu #dummyButton="matMenu"></mat-menu>
                  <button
                    matButton="filled"
                    [matMenuTriggerFor]="menuFilteroption"
                    class="filter-button"
                    (click)="backToFilter('optional-Discount'); showFiltersList = true"
                  >
                    <img
                      [src]="
                        currentUser?.PRODUCTTYPE == 'Solicitor'
                          ? 'assets/icons/filter-icon.png'
                          : 'assets/icons/filter-icon-barrister.png'
                      "
                      alt="Filter"
                      class="filter-icon"
                    />
                    <span>Filters</span>
                  </button>
                  @if (optionalFilters?.length > 0) {
                    <mat-icon class="icon-btn close-btn" (click)="resetFilter()">close</mat-icon>
                  }
                  <mat-menu #menuFilteroption="matMenu" (click)="preventDefault($event)">
                    <div class="filterscroll">
                      @for (optionalFilterData of optionalFilterList; track optionalFilterData) {
                        <div>
                          @if (optionalFilterData.FILTERTYPE != 'HIDDEN') {
                            <div>
                              @if (!optionalFilterData.FILTERAPPLY && showFiltersList) {
                                <button
                                  class="addbutton"
                                  [ngClass]="COLOR"
                                  (click)="
                                    preventDefault($event);
                                    activeCurrentFilter('optional-Discount', optionalFilterData);
                                    addNewFilter(activeOptionalFilter);
                                    showFiltersList = false
                                  "
                                >
                                  <mat-icon>add_circle</mat-icon>
                                  {{ optionalFilterData.DESCRIPTION }}
                                </button>
                              }
                              <div class="menu-submenu" id="optional-Discount">
                                @if (activeOptionalFilter) {
                                  <h5 class="filter-title">
                                    <mat-icon
                                      class="back-icon"
                                      (click)="
                                        backToFilter('optional-Discount');
                                        preventDefault($event);
                                        showFiltersList = true
                                      "
                                    >
                                      arrow_back_ios
                                    </mat-icon>
                                    Filter by
                                    {{ activeOptionalFilter.DESCRIPTION }}
                                  </h5>
                                }
                                @if (activeOptionalFilter) {
                                  <div>
                                    <ng-container formArrayName="FILTERSLIST">
                                      @for (filter of _filterList; track filter; let j = $index) {
                                        <div class="filter-wrapperparent relative grid gap-10">
                                          <ng-container [formGroupName]="j">
                                            <mat-form-field
                                              appearance="outline"
                                              class="width-full"
                                              (click)="preventDefault($event)"
                                            >
                                              <mat-select
                                                (selectionChange)="
                                                  optionalDateFilter($event, filter, 'default', -1)
                                                "
                                                name="OPERATION"
                                                [(ngModel)]="addFilter.OPERATION"
                                                formControlName="OPERATION"
                                                #operationFilter
                                              >
                                                @for (d of filter.DATEFILTERLIST; track d) {
                                                  <mat-option [value]="d.value">
                                                    {{ d.description }}
                                                  </mat-option>
                                                }
                                              </mat-select>
                                            </mat-form-field>
                                            @if (
                                              filter.selectedFilter !== 'is between' &&
                                              (filter.FILTERTYPE == 'NUMBER' ||
                                                filter.FILTERTYPE == 'CURRENCY')
                                            ) {
                                              <div class="flex items-center">
                                                <span class="back-tick">
                                                  @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                                    <img
                                                      src="assets/icons/lefticon2.png"
                                                      alt="Left Arrow"
                                                    />
                                                  } @else {
                                                    <img
                                                      src="assets/icons/lefticon.png"
                                                      alt="Left Arrow"
                                                    />
                                                  }
                                                </span>
                                                @if (filter.FILTERTYPE == 'NUMBER') {
                                                  <mat-form-field
                                                    class="width-full"
                                                    appearance="outline"
                                                    (click)="preventDefault($event)"
                                                  >
                                                    <input
                                                      matInput
                                                      placeholder=""
                                                      name="VALUE"
                                                      formControlName="VALUE"
                                                      [(ngModel)]="addFilter.VALUE"
                                                      [(value)]="addFilter.VALUE"
                                                      required
                                                      appNumberMask
                                                    />
                                                  </mat-form-field>
                                                }
                                                @if (filter.FILTERTYPE == 'CURRENCY') {
                                                  <mat-form-field
                                                    class="width-full"
                                                    appearance="outline"
                                                    (click)="preventDefault($event)"
                                                  >
                                                    <input
                                                      matInput
                                                      placeholder=""
                                                      name="VALUE"
                                                      formControlName="VALUE"
                                                      [(ngModel)]="addFilter.VALUE"
                                                      [(value)]="addFilter.VALUE"
                                                      required
                                                      currencyMask
                                                    />
                                                  </mat-form-field>
                                                }
                                              </div>
                                            }
                                            @if (
                                              filter.FILTERTYPE !== 'NUMBER' &&
                                              filter.FILTERTYPE !== 'CURRENCY' &&
                                              filter.FILTERTYPE !== 'DATE'
                                            ) {
                                              <div class="flex items-center">
                                                <span class="back-tick">
                                                  @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                                    <img
                                                      src="assets/icons/lefticon2.png"
                                                      alt="Left Arrow"
                                                    />
                                                  } @else {
                                                    <img
                                                      src="assets/icons/lefticon.png"
                                                      alt="Left Arrow"
                                                    />
                                                  }
                                                </span>
                                                <mat-form-field
                                                  class="width-full"
                                                  appearance="outline"
                                                  (click)="preventDefault($event)"
                                                >
                                                  <input
                                                    matInput
                                                    placeholder=""
                                                    name="VALUE"
                                                    formControlName="VALUE"
                                                    [(ngModel)]="addFilter.VALUE"
                                                    [(value)]="addFilter.VALUE"
                                                    required
                                                  />
                                                </mat-form-field>
                                              </div>
                                            }
                                            @if (
                                              filter.selectedFilter == 'is between' &&
                                              (filter.FILTERTYPE == 'NUMBER' ||
                                                filter.FILTERTYPE == 'CURRENCY')
                                            ) {
                                              <div class="flex items-center">
                                                <span class="back-tick">
                                                  @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                                    <img
                                                      src="assets/icons/lefticon2.png"
                                                      alt="Left Arrow"
                                                    />
                                                  } @else {
                                                    <img
                                                      src="assets/icons/lefticon.png"
                                                      alt="Left Arrow"
                                                    />
                                                  }
                                                </span>
                                                @if (filter.FILTERTYPE == 'NUMBER') {
                                                  <div
                                                    class="flex items-center"
                                                    (click)="preventDefault($event)"
                                                  >
                                                    <mat-form-field
                                                      class="set-date"
                                                      appearance="outline"
                                                    >
                                                      <input
                                                        matInput
                                                        placeholder=""
                                                        name="VALUE"
                                                        formControlName="VALUE"
                                                        [(ngModel)]="addFilter.VALUE"
                                                        [(value)]="addFilter.VALUE"
                                                        required
                                                        appNumberMask
                                                      />
                                                    </mat-form-field>
                                                    <span class="middle-caption">and</span>
                                                    <mat-form-field
                                                      class="set-date"
                                                      appearance="outline"
                                                    >
                                                      <input
                                                        matInput
                                                        placeholder=""
                                                        name="VALUE2"
                                                        formControlName="VALUE2"
                                                        [(ngModel)]="addFilter.VALUE2"
                                                        [(value)]="addFilter.VALUE2"
                                                        required
                                                        appNumberMask
                                                      />
                                                    </mat-form-field>
                                                  </div>
                                                }
                                                @if (filter.FILTERTYPE == 'CURRENCY') {
                                                  <div
                                                    class="flex items-center"
                                                    (click)="preventDefault($event)"
                                                  >
                                                    <mat-form-field
                                                      class="set-date"
                                                      appearance="outline"
                                                    >
                                                      <input
                                                        matInput
                                                        placeholder=""
                                                        name="VALUE"
                                                        formControlName="VALUE"
                                                        [(ngModel)]="addFilter.VALUE"
                                                        [(value)]="addFilter.VALUE"
                                                        required
                                                        currencyMask
                                                      />
                                                    </mat-form-field>
                                                    <span class="middle-caption">and</span>
                                                    <mat-form-field
                                                      class="set-date"
                                                      appearance="outline"
                                                    >
                                                      <input
                                                        matInput
                                                        placeholder=""
                                                        name="VALUE2"
                                                        formControlName="VALUE2"
                                                        [(ngModel)]="addFilter.VALUE2"
                                                        [(value)]="addFilter.VALUE2"
                                                        required
                                                        currencyMask
                                                      />
                                                    </mat-form-field>
                                                  </div>
                                                }
                                              </div>
                                            }
                                            @if (
                                              filter.FILTERTYPE == 'DATE' &&
                                              filter.selectedFilter &&
                                              filter.selectedFilter !== 'is in the last' &&
                                              filter.selectedFilter !== 'is between' &&
                                              (filter.FILTERTYPE !== 'NUMBER' ||
                                                filter.FILTERTYPE !== 'CURRENCY')
                                            ) {
                                              <div class="flex items-center">
                                                <span class="back-tick">
                                                  @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                                    <img
                                                      src="assets/icons/lefticon2.png"
                                                      alt="Left Arrow"
                                                    />
                                                  } @else {
                                                    <img
                                                      src="assets/icons/lefticon.png"
                                                      alt="Left Arrow"
                                                    />
                                                  }
                                                </span>
                                                <div class="flex items-center">
                                                  <mat-form-field
                                                    appearance="outline"
                                                    class="set-date"
                                                    (click)="preventDefault($event)"
                                                  >
                                                    <input
                                                      matInput
                                                      [matDatepicker]="picker6"
                                                      name="VALUE"
                                                      formControlName="VALUE"
                                                      [(ngModel)]="addFilter.VALUE"
                                                      [(value)]="addFilter.VALUE"
                                                      required
                                                    />
                                                    <mat-datepicker-toggle
                                                      matSuffix
                                                      [for]="picker6"
                                                    ></mat-datepicker-toggle>
                                                    <mat-datepicker #picker6></mat-datepicker>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                            }
                                            @if (
                                              (filter.FILTERTYPE == 'DATE' &&
                                                !filter.selectedFilter) ||
                                              (filter.selectedFilter == 'is in the last' &&
                                                (filter.FILTERTYPE !== 'NUMBER' ||
                                                  filter.FILTERTYPE !== 'CURRENCY'))
                                            ) {
                                              <div class="flex items-center">
                                                <span class="back-tick">
                                                  @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                                    <img
                                                      src="assets/icons/lefticon2.png"
                                                      alt="Left Arrow"
                                                    />
                                                  } @else {
                                                    <img
                                                      src="assets/icons/lefticon.png"
                                                      alt="Left Arrow"
                                                    />
                                                  }
                                                </span>
                                                <div
                                                  class="field-box flex items-center"
                                                  (click)="preventDefault($event)"
                                                >
                                                  <mat-form-field
                                                    class="set-date"
                                                    appearance="outline"
                                                  >
                                                    <input
                                                      matInput
                                                      placeholder=""
                                                      name="VALUE"
                                                      formControlName="VALUE"
                                                      [(ngModel)]="addFilter.VALUE"
                                                      [(value)]="addFilter.VALUE"
                                                      required
                                                    />
                                                  </mat-form-field>
                                                  <mat-form-field
                                                    appearance="outline"
                                                    class="set-date"
                                                  >
                                                    <mat-select
                                                      [value]="'days'"
                                                      formControlName="VALUE2"
                                                      [(ngModel)]="addFilter.VALUE2"
                                                      [(value)]="addFilter.VALUE2"
                                                      required
                                                    >
                                                      <mat-option value="days">Days</mat-option>
                                                      <mat-option value="month">Month</mat-option>
                                                    </mat-select>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                            }
                                            @if (
                                              filter.FILTERTYPE == 'DATE' &&
                                              filter.selectedFilter == 'is between' &&
                                              (filter.FILTERTYPE !== 'NUMBER' ||
                                                filter.FILTERTYPE !== 'CURRENCY')
                                            ) {
                                              <div class="flex items-center">
                                                <mat-form-field
                                                  appearance="outline"
                                                  class="set-date"
                                                  (click)="preventDefault($event)"
                                                >
                                                  <input
                                                    matInput
                                                    [matDatepicker]="picker"
                                                    #StartDate
                                                    name="VALUE"
                                                    formControlName="VALUE"
                                                    [(ngModel)]="addFilter.VALUE"
                                                    [(value)]="addFilter.VALUE"
                                                    required
                                                  />
                                                  <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker"
                                                  ></mat-datepicker-toggle>
                                                  <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                                <span class="middle-caption">and</span>
                                                <mat-form-field
                                                  appearance="outline"
                                                  class="set-date"
                                                  (click)="preventDefault($event)"
                                                >
                                                  <input
                                                    matInput
                                                    [matDatepicker]="picker2"
                                                    #EndDate
                                                    name="VALUE2"
                                                    formControlName="VALUE2"
                                                    [(ngModel)]="addFilter.VALUE2"
                                                    [(value)]="addFilter.VALUE2"
                                                    required
                                                  />
                                                  <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker2"
                                                  ></mat-datepicker-toggle>
                                                  <mat-datepicker #picker2></mat-datepicker>
                                                </mat-form-field>
                                              </div>
                                            }
                                            <button
                                              mat-raised-button
                                              color="primary"
                                              class="width-full accent"
                                              (click)="addfilter(filter, operationFilter, $event)"
                                            >
                                              Apply
                                            </button>
                                          </ng-container>
                                        </div>
                                      }
                                    </ng-container>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-menu>
                  <mat-icon
                    class="icon-btn refresh-btn"
                    id="refreshUser"
                    (click)="refreshUserTab(false)"
                  >
                    refresh
                  </mat-icon>
                </div>
                <div class="relative">
                  <mat-icon
                    class="badge-ic"
                    (click)="
                      activeFilters && activeFilters.active
                        ? clearFilter('active', 'Active')
                        : false;
                      $event.stopPropagation()
                    "
                  >
                    {{ activeFilters && activeFilters.active ? 'cancel_circle' : 'add_circle' }}
                  </mat-icon>
                  <button
                    mat-button
                    [matMenuTriggerFor]="activeMenucard"
                    class="buttonwith-text dotted-button h-[25px]"
                  >
                    Active
                    <span class="filter-applytext flex items-center">
                      {{
                        activeFilters && activeFilters.activeDesc ? activeFilters.activeDesc : ''
                      }}
                      <mat-icon class="rightdownarrow">keyboard_arrow_down</mat-icon>
                    </span>
                  </button>
                  <mat-menu #activeMenucard="matMenu" #menu>
                    <mat-radio-group
                      formControlName="ACTIVE"
                      aria-labelledby="example-radio-group-label"
                      class="filter-radio-group"
                    >
                      @for (season of activeFilterdata; track season) {
                        <mat-radio-button
                          (change)="Filterconfig(season, 'Active'); UserTypeChange($event)"
                          class="filter-radio-button"
                          disableRipple="true"
                          [value]="season.id"
                        >
                          {{ season.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </mat-menu>
                </div>

                <div class="relative">
                  <div class="pill-filter search-pill">
                    @if (hasSearchVal) {
                      <mat-icon
                        class="left-icon"
                        (click)="
                          onFilterSearch('removeSearchString');
                          clearFilter('Search', 'Search');
                          $event.stopPropagation()
                        "
                      >
                        cancel
                      </mat-icon>
                    }
                    <span class="label">Search</span>
                    <span class="value filter-applytext flex items-center">
                      <input
                        matInput
                        #searchField
                        (keyup)="Filterconfig($event, 'SearchString'); onSearchChange($event)"
                        formControlName="searchFilter"
                        tabindex="6"
                        class="text-left"
                      />
                      <mat-icon matSuffix (click)="onFilterSearch('Enter'); preventDefault($event)">
                        search
                      </mat-icon>
                    </span>
                  </div>
                </div>
                <ng-container formArrayName="FILTERS">
                  @for (filter of optionalFilters; track filter; let i = $index) {
                    <div class="relative">
                      <ng-container [formGroupName]="i">
                        <button
                          mat-button
                          [matMenuTriggerFor]="menuCreatedDate_i"
                          class="buttonwith-text pill-filter"
                          (click)="setFilterUi(filter, i)"
                        >
                          {{ filter.DESCRIPTION }}
                          <span class="filter-applytext value flex items-center">
                            {{
                              optionalDateFilterPayload[i] &&
                              optionalDateFilterPayload[i]['value'] !== null
                                ? optionalDateFilterPayload[i]['value'].VALUE
                                : ''
                            }}
                            {{
                              optionalDateFilterPayload[i] &&
                              optionalDateFilterPayload[i]['value'] !== null &&
                              optionalDateFilterPayload[i]['value'].VALUE2 !== '' &&
                              optionalDateFilterPayload[i]['value'].VALUE2 !== null
                                ? ' - ' + optionalDateFilterPayload[i]['value'].VALUE2
                                : ''
                            }}
                            <mat-icon class="rightdownarrow">keyboard_arrow_down</mat-icon>
                          </span>
                        </button>
                        <mat-icon
                          class="badge-ic"
                          (click)="
                            resetOptionalFilter(filter, filter.FILTERTYPE, i);
                            $event.stopPropagation()
                          "
                          style="z-index: 10"
                        >
                          cancel_circle
                        </mat-icon>
                        <mat-menu #menuCreatedDate_i="matMenu">
                          <h5 class="filter-title">
                            Filter by
                            {{ filter.DESCRIPTION }}
                          </h5>
                          <mat-form-field
                            appearance="outline"
                            class="width-full mb-4"
                            (click)="preventDefault($event)"
                          >
                            <mat-select
                              (selectionChange)="optionalDateFilter($event, filter, 'active', i)"
                              name="OPERATION"
                              formControlName="OPERATION"
                              #Datefilter
                            >
                              @for (d of filter.DATEFILTERLIST; track d) {
                                <mat-option [value]="d.value">
                                  {{ d.description }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          @if (
                            filter.selectedFilter !== 'is between' &&
                            (filter.FILTERTYPE == 'NUMBER' || filter.FILTERTYPE == 'CURRENCY')
                          ) {
                            <div class="flex items-center">
                              <span class="back-tick">
                                @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                  <img src="assets/icons/lefticon2.png" alt="Left Arrow" />
                                } @else {
                                  <img src="assets/icons/lefticon.png" alt="Left Arrow" />
                                }
                              </span>
                              @if (filter.FILTERTYPE == 'NUMBER') {
                                <mat-form-field
                                  class="width-full mb-4"
                                  appearance="outline"
                                  (click)="preventDefault($event)"
                                >
                                  <input
                                    matInput
                                    placeholder=""
                                    name="VALUE"
                                    formControlName="VALUE"
                                    required
                                    appNumberMask
                                  />
                                </mat-form-field>
                              }
                              @if (filter.FILTERTYPE == 'CURRENCY') {
                                <mat-form-field
                                  class="width-full mb-4"
                                  appearance="outline"
                                  (click)="preventDefault($event)"
                                >
                                  <input
                                    matInput
                                    placeholder=""
                                    name="VALUE"
                                    formControlName="VALUE"
                                    required
                                    currencyMask
                                  />
                                </mat-form-field>
                              }
                            </div>
                          }
                          @if (
                            filter.FILTERTYPE !== 'NUMBER' &&
                            filter.FILTERTYPE !== 'CURRENCY' &&
                            filter.FILTERTYPE !== 'DATE'
                          ) {
                            <div class="flex items-center">
                              <span class="back-tick">
                                @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                  <img src="assets/icons/lefticon2.png" alt="Left Arrow" />
                                } @else {
                                  <img src="assets/icons/lefticon.png" alt="Left Arrow" />
                                }
                              </span>
                              <mat-form-field
                                class="width-full mb-4"
                                appearance="outline"
                                (click)="preventDefault($event)"
                              >
                                <input
                                  matInput
                                  placeholder=""
                                  name="VALUE"
                                  formControlName="VALUE"
                                  required
                                />
                              </mat-form-field>
                            </div>
                          }
                          @if (
                            filter.selectedFilter == 'is between' &&
                            (filter.FILTERTYPE == 'NUMBER' || filter.FILTERTYPE == 'CURRENCY')
                          ) {
                            <div class="flex items-center">
                              <span class="back-tick">
                                @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                  <img src="assets/icons/lefticon2.png" alt="Left Arrow" />
                                } @else {
                                  <img src="assets/icons/lefticon.png" alt="Left Arrow" />
                                }
                              </span>
                              @if (filter.FILTERTYPE == 'NUMBER') {
                                <div class="flex items-center" (click)="preventDefault($event)">
                                  <mat-form-field class="set-date mb-4" appearance="outline">
                                    <input
                                      matInput
                                      placeholder=""
                                      name="VALUE"
                                      formControlName="VALUE"
                                      required
                                      appNumberMask
                                    />
                                  </mat-form-field>
                                  <span class="middle-caption">and</span>
                                  <mat-form-field class="set-date mb-4" appearance="outline">
                                    <input
                                      matInput
                                      placeholder=""
                                      name="VALUE2"
                                      formControlName="VALUE2"
                                      required
                                      appNumberMask
                                    />
                                  </mat-form-field>
                                </div>
                              }
                              @if (filter.FILTERTYPE == 'CURRENCY') {
                                <div class="flex items-center" (click)="preventDefault($event)">
                                  <mat-form-field class="set-date mb-4" appearance="outline">
                                    <input
                                      matInput
                                      placeholder=""
                                      name="VALUE"
                                      formControlName="VALUE"
                                      required
                                      currencyMask
                                    />
                                  </mat-form-field>
                                  <span class="middle-caption">and</span>
                                  <mat-form-field class="set-date mb-4" appearance="outline">
                                    <input
                                      matInput
                                      placeholder=""
                                      name="VALUE2"
                                      formControlName="VALUE2"
                                      required
                                      currencyMask
                                    />
                                  </mat-form-field>
                                </div>
                              }
                            </div>
                          }
                          @if (
                            filter.FILTERTYPE == 'DATE' &&
                            filter.selectedFilter &&
                            filter.selectedFilter !== 'is in the last' &&
                            filter.selectedFilter !== 'is between' &&
                            (filter.FILTERTYPE !== 'NUMBER' || filter.FILTERTYPE !== 'CURRENCY')
                          ) {
                            <div class="flex items-center">
                              <span class="back-tick">
                                @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                  <img src="assets/icons/lefticon2.png" alt="Left Arrow" />
                                } @else {
                                  <img src="assets/icons/lefticon.png" alt="Left Arrow" />
                                }
                              </span>
                              <div class="flex items-center">
                                <mat-form-field
                                  appearance="outline"
                                  class="set-date mb-4"
                                  (click)="preventDefault($event)"
                                >
                                  <input
                                    matInput
                                    [matDatepicker]="picker6"
                                    name="VALUE"
                                    formControlName="VALUE"
                                    required
                                  />
                                  <mat-datepicker-toggle
                                    matSuffix
                                    [for]="picker6"
                                  ></mat-datepicker-toggle>
                                  <mat-datepicker #picker6></mat-datepicker>
                                </mat-form-field>
                              </div>
                            </div>
                          }
                          @if (
                            (filter.FILTERTYPE == 'DATE' && !filter.selectedFilter) ||
                            (filter.selectedFilter == 'is in the last' &&
                              (filter.FILTERTYPE !== 'NUMBER' || filter.FILTERTYPE !== 'CURRENCY'))
                          ) {
                            <div class="flex items-center">
                              <span class="back-tick">
                                @if (currentUser?.PRODUCTTYPE === 'Barrister') {
                                  <img src="assets/icons/lefticon2.png" alt="Left Arrow" />
                                } @else {
                                  <img src="assets/icons/lefticon.png" alt="Left Arrow" />
                                }
                              </span>
                              <div
                                class="field-box flex items-center"
                                (click)="preventDefault($event)"
                              >
                                <mat-form-field class="set-date mb-4" appearance="outline">
                                  <input
                                    matInput
                                    placeholder=""
                                    name="VALUE"
                                    formControlName="VALUE"
                                    required
                                  />
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="set-date mb-4">
                                  <mat-select [value]="'days'" formControlName="VALUE2" required>
                                    <mat-option value="days">Days</mat-option>
                                    <mat-option value="month">Month</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          }
                          @if (
                            filter.FILTERTYPE == 'DATE' &&
                            filter.selectedFilter == 'is between' &&
                            (filter.FILTERTYPE !== 'NUMBER' || filter.FILTERTYPE !== 'CURRENCY')
                          ) {
                            <div class="flex items-center">
                              <mat-form-field
                                appearance="outline"
                                class="set-date mb-4"
                                (click)="preventDefault($event)"
                              >
                                <input
                                  matInput
                                  [matDatepicker]="picker"
                                  #StartDate
                                  name="VALUE"
                                  formControlName="VALUE"
                                  required
                                />
                                <mat-datepicker-toggle
                                  matSuffix
                                  [for]="picker"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                              </mat-form-field>
                              <span class="middle-caption">and</span>
                              <mat-form-field
                                appearance="outline"
                                class="set-date"
                                (click)="preventDefault($event)"
                              >
                                <input
                                  matInput
                                  [matDatepicker]="picker2"
                                  #EndDate
                                  name="VALUE2"
                                  formControlName="VALUE2"
                                  required
                                />
                                <mat-datepicker-toggle
                                  matSuffix
                                  [for]="picker2"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                              </mat-form-field>
                            </div>
                          }
                          <!-- GSM -->
                          <!-- <div class="items-center flex flex-wrap time-selection" *ngIf="(filter.FILTERTYPE == 'DATE'&& !filter.selectedFilter || filter.selectedFilter == 'is in the last')">
                                                                <span class="timeselection-text">TIme zone:</span>
                                                                <mat-radio-group aria-label="Select an option" (click)="preventDefault($event)">
                                                                  <mat-radio-button value="1">GMT + 10</mat-radio-button>
                                                                  <mat-radio-button value="2">UTC</mat-radio-button>
                                                                </mat-radio-group>
                                                              </div> -->
                          <button
                            mat-raised-button
                            color="primary"
                            class="width-full accent"
                            (click)="
                              applayOptionalfilter(
                                optionalFilters[i],
                                i,
                                Datefilter,
                                $event,
                                'isDynamic'
                              )
                            "
                          >
                            Apply
                          </button>
                        </mat-menu>
                      </ng-container>
                    </div>
                  }
                </ng-container>
              </div>
            </form>
          </div>

          @if (currentMenu !== 'userActivity') {
            <div class="user-action-btn flex flex-wrap gap-y-[8px]">
              <button
                mat-flat-button
                color="accent"
                class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 px-[10px]"
                (click)="showUserLoggedOnPopup()"
              >
                <mat-icon class="fs-17 t3">add</mat-icon>
                Logged On Users
              </button>
              <button
                mat-flat-button
                color="accent"
                [ngClass]="
                  appPermissions?.[29]?.Create == 0 ? 'disabled-click large-button' : 'large-button'
                "
                class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 px-[10px]"
                (click)="userDialog('new')"
              >
                <mat-icon class="fs-17 t3">add</mat-icon>
                Add
              </button>
              <button
                mat-flat-button
                color="accent"
                [ngClass]="
                  appPermissions?.[29]?.Edit == 0 || isUserData == 'empty'
                    ? 'disabled-click large-button'
                    : 'large-button'
                "
                class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 px-[10px]"
                (click)="userDialog('edit')"
                id="editUserBtn"
              >
                <mat-icon class="fs-17 t3">edit</mat-icon>
                Edit
              </button>
              <button
                mat-flat-button
                color="accent"
                [ngClass]="
                  appPermissions?.[29]?.Delete == 0 || isUserData == 'empty'
                    ? 'disabled-click large-button'
                    : 'large-button'
                "
                class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 px-[10px]"
                (click)="DeleteUser()"
              >
                <mat-icon class="fs-17 t3">delete</mat-icon>
                Delete
              </button>
              <button
                mat-flat-button
                color="accent"
                class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 px-[10px]"
                (click)="userDialog('duplicate')"
              >
                <mat-icon class="fs-17 t3">file_copy</mat-icon>
                Duplicate
              </button>
              <button
                mat-flat-button
                color="accent"
                [disabled]="permissionSsoDesc[50]?.ALLOWED !== 1"
                [matMenuTriggerFor]="ssoMenu"
                class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 px-[10px]"
              >
                <mat-icon class="fs-17 t3">add</mat-icon>
                SSO
              </button>
              <mat-menu #ssoMenu="matMenu">
                <button mat-menu-item (click)="enableMsSSOUser()">Enable MS SSO</button>
                <button mat-menu-item (click)="disableMsSSOUser()">Disable MS SSO</button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="enableMsSSOAllUsers()">
                  Enable MS SSO for all users
                </button>
                <button mat-menu-item (click)="disableMsSSOAllUsers()">
                  Disable MS SSO for all users
                </button>
              </mat-menu>
            </div>
          }
        </div>
      </div>
      <div class="users-table-section flex-grow-1">
        @if (currentMenu == null) {
          <div
            class="btn top_right_action_billing_position dot_controller top-[-12px] right-[-14px] h-[66px] w-[80px]"
          >
            <button mat-icon-button [matMenuTriggerFor]="contextMenu" aria-label="More">
              <mat-icon class="secondary-text">more_vert</mat-icon>
            </button>
            <mat-menu #contextMenu="matMenu">
              <ng-template matMenuContent let-item="item">
                <button mat-menu-item (click)="openDialog()">Field Configuration</button>
                <button mat-menu-item (click)="refreshData()">Reload Data</button>
                <button mat-menu-item (click)="downloadFile(Useralldata.data)">
                  <img src="assets/icons/web_app/EXP_CSV.ico" />
                  Export to CSV
                </button>
              </ng-template>
            </mat-menu>
          </div>

          <div class="example-containerdata resizable-table users-tablewrap">
            @if (isDisplay) {
              <div class="grid-overlay">
                <div class="grid-overlay-msg">There is no data to display.</div>
              </div>
            }
            <table
              mat-table
              #table
              [dataSource]="Useralldata"
              (matSortChange)="sortData($event)"
              matSortActive="{{ sortactive }}"
              matSortDirection="{{ sortDirection }}"
              matSortDisableClear
              matSort
              [@animateStagger]="{ value: '50' }"
            >
              @for (item of displayedColumns; track item; let i = $index) {
                <ng-container matColumnDef="{{ item }}">
                  <th
                    mat-header-cell
                    *matHeaderCellDef="let i = index"
                    mat-sort-header
                    class="header_title mat-column-{{ item }}"
                    mwlResizable
                    [enableGhostResize]="false"
                    (resizing)="onResizing($event, item)"
                    (resizeEnd)="onResizeEnd($event, item)"
                    [resizeEdges]="{
                      bottom: false,
                      right: true,
                      top: false,
                      left: true,
                    }"
                  >
                    <div
                      class="desc_cell resize-handle-right"
                      mwlResizeHandle
                      [resizeEdges]="{ right: true }"
                      (mousedown)="$event.stopPropagation()"
                      (click)="$event.stopPropagation()"
                    ></div>
                    {{ tempColobj[item].DESCRIPTION }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row"
                    class="text-{{ tempColobj[item].JUSTIFICATION }}-align mat-column-{{ item }}"
                    [ngClass]="{ 'word-wrap-class': tempColobj[item].WIDEDATA }"
                  >
                    @if (row[item] !== undefined) {
                      <span>
                        {{
                          row[item]
                            | toFixedAmount: tempColobj[item].CURRENCY
                            | wordwrap: tempColobj[item].WIDEDATA
                        }}
                      </span>
                    }
                  </td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr
                mat-row
                [style.background]="highlightedRows == row.USERGUID ? selectedColore : ''"
                *matRowDef="let row; columns: displayedColumns"
                [ngClass]="highlightedRows == row.USERGUID ? 'row-text-colore' : ''"
                class="contact"
                (click)="
                  setActiveUserData(row); currentUserData = row; highlightedRows = row.USERGUID
                "
                [@animate]="{ value: '*', params: { y: '100%' } }"
                (dblclick)="doubleClick($event)"
              ></tr>
            </table>
          </div>
          <mat-paginator
            [pageSizeOptions]="[10, 20, 50, 100]"
            [pageSize]="$safeNavigationMigration(pageSize?.user_page)"
            (page)="onPaginateChange($event)"
            showFirstLastButtons
          ></mat-paginator>
        }
      </div>
    </div>
  </div>
</div>
